import { Button } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

export function MealCreditsAction(): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  const { push } = useHistory();

  return (
    <Button
      variant="primary"
      buttonSize="medium"
      block
      onClick={() => {
        push(`/corporate/management/${corpid}/lineOfCredit`);
      }}
    >
      View meal credits
    </Button>
  );
}
